import { DeletedStoreDto } from './deleted-store.dto';

export class DeletedStore {
    readonly id: string;
    readonly isDeleted: boolean;

    constructor(dto: DeletedStoreDto) {
        this.id = dto.id;
        this.isDeleted = dto.isDeleted;
    }
}
